var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTagSimple = function SvgIconTagSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.593 4.25a1.74 1.74 0 0 1 1.467.787l4.272 6.408a1 1 0 0 1 0 1.11l-4.272 6.408a1.74 1.74 0 0 1-1.467.787h-.005l.009-1v1H3.75A1.75 1.75 0 0 1 2 18V6a1.75 1.75 0 0 1 1.75-1.75zm0 0h-.005l.009 1v-1zm-.128 2H4v11.5h13.465L21.298 12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTagSimple;